export default __webpack_public_path__ + "static/media/hov_shape_s.ab947705.svg";